module.exports = __webpack_public_path__ + "static/media/26.4ed97354.mp3";